import React from "react";
import WebService from "../Services/WebService";
import { clearAppStorage } from "../utils/authStorage";
export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.JSX.Element;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  if (localStorage.getItem("access_token") != null) {
    return outlet;
  } else {
    const url = `${window.location.protocol}//${window.location.host}/login`;
    clearAppStorage();
    window.location.assign(url);
    return outlet;
  }
}
